/** Espace Coach public : tâches assignées au coach avec case « fait ». */
import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../lib/api";
import { toast } from "sonner";

const PRIO = { haute: "border-red-500/40 text-red-300", moyenne: "border-amber-500/40 text-amber-300", basse: "border-zinc-600 text-zinc-300" };

export function CoachSpaceTasks({ slug }) {
  const [data, setData] = useState(null);
  const load = () => axios.get(`${API}/public/coach-space/${slug}/tasks`).then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, [slug]); // eslint-disable-line
  if (!data || data.items.length === 0) return null;
  const toggle = async (t) => {
    try { await axios.patch(`${API}/public/coach-space/${slug}/tasks/${t.id}`, { done: t.statut !== "termine" }); toast.success(t.statut !== "termine" ? "✅ Tâche faite — merci !" : "Tâche rouverte"); load(); }
    catch { toast.error("Erreur"); }
  };
  const open = data.items.filter((t) => t.statut !== "termine");
  return (
    <section className="mt-8 rounded-2xl border border-amber-500/30 bg-zinc-900/60 p-5" data-testid="coach-tasks">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-base md:text-lg font-bold text-zinc-100">📋 Mes tâches assignées</h2>
        <span className="text-xs text-zinc-400" data-testid="coach-tasks-count">{open.length} à faire · {data.items.length - open.length} faites</span>
      </div>
      <ul className="space-y-2">
        {data.items.map((t) => (
          <li key={t.id}>
            <label className={`flex items-start gap-3 rounded-xl border p-3 cursor-pointer ${t.statut === "termine" ? "border-emerald-500/30 bg-emerald-500/5" : "border-zinc-800 bg-zinc-950/60 hover:border-zinc-600"}`}>
              <input type="checkbox" checked={t.statut === "termine"} onChange={() => toggle(t)} className="mt-1 w-4 h-4 accent-emerald-500" data-testid={`coach-task-${t.id}`} />
              <div className="flex-1 min-w-0">
                <div className={`text-sm font-semibold ${t.statut === "termine" ? "line-through text-zinc-500" : "text-zinc-100"}`}>{t.titre}</div>
                <div className="text-xs text-zinc-500 mt-0.5 flex flex-wrap gap-2 items-center">
                  <span className={`px-1.5 py-0.5 rounded border text-[10px] ${PRIO[t.priorite] || PRIO.basse}`}>{t.priorite}</span>
                  {t.due_date && <span>Échéance : <b className="text-zinc-300">{t.due_date}</b></span>}
                  {t.done_at && <span className="text-emerald-400">fait le {t.done_at.slice(0, 10)}</span>}
                </div>
              </div>
            </label>
          </li>
        ))}
      </ul>
    </section>
  );
}
